import MapSectionOsiedle from "./MapSectionOsiedle";
export default MapSectionOsiedle;